let locales = {
    role: 'Role',
    roles: 'Roles',
    role_permissions: 'Permisos',
    roles_access: "Permitir",
};

//import list from '../../views/list/lan/es'
import edit from '../../modals/edit/lan/es'

locales = {
    ...locales,
    //...list,
    ...edit
}

export default locales;